import React, { useState } from 'react';
import { TickIcon2 } from 'images/common';

import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {unsubscribeReport} from 'api/reports';

import { defaultNotifier } from 'functions/notificationHandler';
import LoadingIndicator from 'components/LoadingIndicator';

export const UnsubscribedPage = ({
  parentClass,
}) => {
  const [isLoading, setLoading] = useState(false)
  const { token } = useParams();

  useEffect(() => {
    const fetchUnsubscribe = async () => {
      if (token) {
        setLoading(true);
        try {
          const data = await unsubscribeReport(token);

          defaultNotifier(data?.data?.message)
          setLoading(false);
        } catch (err) {
          const data = err;
          // setLoading(false);
          defaultNotifier(data?.response?.statusText || 'Failed to unsubscribe');
        }
      }
    };
  
    fetchUnsubscribe();
  }, [token]);

  if (isLoading) {
    return <LoadingIndicator isProcessPage />;
  }

  return (
    <main className={`not-found__wrapper ${parentClass}`}>
      <div className="not-found__circle"><TickIcon2 /></div>

      <div>
        <div className="not-found__text">Unsubscribed</div>
        <p className="not-found__description">You’ll no longer get emails for this report.
          Change your mind later? Any teammate who can manage the report can easily add you back as a recipient.</p>
      </div>
    </main>
  )
};

export default UnsubscribedPage;
